var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-spin',{attrs:{"size":_vm.size,"tip":_vm.tip}},[_c('a-icon',{staticStyle:{"font-size":"32px","margin-bottom":"12px"},attrs:{"slot":"indicator","type":"loading","spin":""},slot:"indicator"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }